import React from 'react';
import { Link } from 'react-router-dom';
import Logisticsteam from '../assets/images/data/Logistics-team.jpg';

const CTA = () => {
  return (
    <section className="w-full overflow-hidden bg-gradient-to-r from-[#fff44f] via-[#fff86f] to-[#fffcb0] py-16 px-6 rounded-xl shadow-md">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8">
        {/* CTA Content */}
        <div className="flex-1 text-center lg:text-left px-4">
          <h2 className="text-3xl lg:text-4xl font-extrabold text-[#211f57] mb-4 leading-tight">
            Streamline Your Logistics with <br />
            <span className="text-red-600">S Infinite Express</span>
          </h2>

          <p className="text-gray-800 text-lg mb-6">
            Deliver faster, smarter, and more reliably across India. Partner with us for end-to-end logistics solutions that scale with your business.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
            <Link
              to="/get-a-quote"
              className="bg-red-600 hover:bg-red-700 text-white font-semibold px-6 py-3 rounded-lg shadow transition-transform transform hover:-translate-y-1 text-center"
            >
              Get a Quote
            </Link>
            <Link
              to="/pickup-request"
              className="bg-white text-[#211f57] hover:bg-gray-100 border border-[#211f57] font-semibold px-6 py-3 rounded-lg shadow transition-transform transform hover:-translate-y-1 text-center"
            >
              Pickup Request
            </Link>
          </div>
        </div>

        {/* CTA Image */}
        <div className="flex-1 hidden lg:block rounded-lg overflow-hidden shadow-md">
          <img
            src={Logisticsteam}
            alt="Logistics team at work"
            className="w-full h-80 object-cover"
          />
        </div>
      </div>
    </section>
  );
};

export default CTA;
